"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PreviewDoughnut = _interopRequireDefault(require("./PreviewDoughnut.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var PreviewDoughnut = /*#__PURE__*/function (_React$Component) {
  _inherits(PreviewDoughnut, _React$Component);
  var _super = _createSuper(PreviewDoughnut);
  function PreviewDoughnut(props) {
    var _this;
    _classCallCheck(this, PreviewDoughnut);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }
  _createClass(PreviewDoughnut, [{
    key: "render",
    value: function render() {
      var halfsize = this.props.size * 0.5;
      var radius = halfsize - this.props.strokewidth * 0.5;
      var circumference = 2 * Math.PI * radius;
      var strokeval = this.props.value * circumference / 100;
      var dashval = "".concat(strokeval, " ").concat(circumference);
      var textDYValue = halfsize - halfsize * 0.65 * -0.25;
      var trackstyle = {
        strokeWidth: this.props.strokewidth
      };
      var indicatorstyle = {
        strokeWidth: this.props.strokewidth,
        strokeDasharray: dashval
      };
      var rotateval = "rotate(-90 ".concat(halfsize, ",").concat(halfsize, ")");
      return /*#__PURE__*/_react["default"].createElement(_PreviewDoughnut["default"], {
        isDefault: this.props.isDefault,
        isActive: this.props.isActive,
        colorScheme: this.props.color,
        DoughnutSize: halfsize,
        className: "preview-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: this.props.size,
        height: this.props.size,
        className: "DoughnutChart"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        r: radius,
        cx: halfsize,
        cy: halfsize,
        transform: rotateval,
        style: trackstyle,
        className: "DoughnutChart-track"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        r: radius,
        cx: halfsize,
        cy: halfsize,
        transform: rotateval,
        style: indicatorstyle,
        className: "DoughnutChart-indicator"
      }), /*#__PURE__*/_react["default"].createElement("text", {
        className: "DoughnutChart-text",
        x: halfsize,
        dy: textDYValue,
        textAnchor: "middle",
        dominantBaseline: "reset-size"
      }, /*#__PURE__*/_react["default"].createElement("tspan", {
        className: "DoughnutChart-text-val"
      }, this.props.value, "%"))));
    }
  }]);
  return PreviewDoughnut;
}(_react["default"].Component);
PreviewDoughnut.propTypes = {
  /** Value the chart should show */
  value: _propTypes["default"].number,
  /** Diameter of chart */
  size: _propTypes["default"].number,
  /** Width of chart line */
  strokewidth: _propTypes["default"].number,
  /** Color of chart indicator. String 'category[*]' - [*] = 0 to 10. e.g (category0). */
  color: _propTypes["default"].string,
  /** State of the component */
  isActive: _propTypes["default"].bool,
  /** Default state of the component */
  isDefault: _propTypes["default"].bool
};
PreviewDoughnut.defaultProps = {
  value: 0,
  size: 116,
  strokewidth: 8,
  color: '',
  isActive: false,
  isDefault: false
};
PreviewDoughnut.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PreviewDoughnut",
  "props": {
    "value": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "Value the chart should show",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "116",
        "computed": false
      },
      "description": "Diameter of chart",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "strokewidth": {
      "defaultValue": {
        "value": "8",
        "computed": false
      },
      "description": "Width of chart line",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "color": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Color of chart indicator. String 'category[*]' - [*] = 0 to 10. e.g (category0).",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isActive": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "State of the component",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isDefault": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Default state of the component",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};
var _default = PreviewDoughnut;
exports["default"] = _default;